import React from 'react';

const EFFECT_LINES = Array.apply(null, { length: 11 });

const JobLoading = () =>
  <div className="job-placeholder-loading">
    <div className="panel-effect">
      {EFFECT_LINES.map((el, i) =>
        <div key={i} className={`fake-effect fe-${i}`} />
      )}
    </div>
  </div>;

export default JobLoading;
